import type { TimelineEvent } from "@productlane/api/src/browser"

const FEEDBACK_PREFIX = /^AI chat feedback:\s*/i
const SENTIMENT_EMOJI = /[\u{1F44D}\u{1F44E}]/gu

export interface AiChatFeedbackComment {
	sentiment: "positive" | "negative"
	text: string
}

// Legacy widgets wrote the feedback as an authorless comment; newer ones create
// an ai_chat_feedback activity instead.
export function parseAiChatFeedbackComment(
	raw: string,
): AiChatFeedbackComment | null {
	const text = raw
		.replace(/<[^>]*>/g, " ")
		.replace(/\s+/g, " ")
		.trim()
	if (!FEEDBACK_PREFIX.test(text)) return null

	const body = text
		.replace(FEEDBACK_PREFIX, "")
		.replace(SENTIMENT_EMOJI, "")
		.replace(/\s+([:.,])/g, "$1")
		.replace(/\s+/g, " ")
		.trim()
	if (!body) return null

	return {
		sentiment: /disliked/i.test(body) ? "negative" : "positive",
		text: body,
	}
}

export function getAiChatFeedbackComment(
	event: TimelineEvent,
): AiChatFeedbackComment | null {
	if (
		event.type !== "comment" ||
		event.comment.userId ||
		event.comment.linearCommentId
	) {
		return null
	}
	return parseAiChatFeedbackComment(event.comment.content)
}
